import { AlertMessageCondition } from "../../app/contexts/AlertMessaging/types";
import englishTranslations from "../../translations/en-US.json";

/**
 * @constant
 * Object map of AlertMessageCondition to Topics (`strings`) used for analytics
 */
export const alertMessageConditionTopicMap = {
  [AlertMessageCondition.NoSavedPharmacies]:
    englishTranslations["lcp.messages.no_saved_pharmacies.topic"],
  [AlertMessageCondition.NoSavedDrugs]:
    englishTranslations["lcp.messages.no_saved_drugs.topic"],
  [AlertMessageCondition.OneSavedPharmacy]:
    englishTranslations["lcp.messages.one_saved_pharmacy.topic"],
  [AlertMessageCondition.OneSavedPharmacyStaleAccount]:
    englishTranslations["lcp.messages.one_saved_pharmacy.stale_account.topic"],
  [AlertMessageCondition.NoInNetworkSavedPharmacies]:
    englishTranslations["lcp.messages.no_in_network_pharmacies.topic"],
  [AlertMessageCondition.NoPreferredSavedPharmacies]:
    englishTranslations["lcp.messages.no_preferred_pharmacies.topic"],
  [AlertMessageCondition.StaleAccountPharmacies]:
    englishTranslations["lcp.messages.stale_account.pharmacies.topic"],
  [AlertMessageCondition.StaleAccountDrugs]:
    englishTranslations["lcp.messages.stale_account.drugs.topic"],
};

export const alertMessageTestId = "alert-message";
export const alertMessageBodyTestId = `${alertMessageTestId}__body`;
export const alertMessageTitleTestId = `${alertMessageTestId}__title`;
export const alertMessageActionTestId = `${alertMessageTestId}__action`;
